import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { RemissionService } from '../../services/remission.service';
import { CustomerSupplierId, CustomerSupplierService } from '../../services/customer-supplier.service';
import { Observable } from 'rxjs/Observable';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ProductionOrderService } from '../../services/production-order.service';
import { Utils } from '../../util';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { CustomerBillId, CustomerBillService } from '../../services/customer-bill.service';
import { Subscription } from 'rxjs';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { Globals } from '../../globals';
import { FiscalDataId } from '../../services/fiscal-data.service';
import { AddressId } from '../../services/address.service';

@Component({
  selector: 'app-read-remission',
  templateUrl: './read-remission.component.html',
  styleUrls: ['./read-remission.component.css']
})
export class ReadRemissionComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  loaded: boolean = false;
  permission: any = {};

  remissions:any;
  billsById: {[id: string]: CustomerBillId} = {};
  customersById: {[id: string]: CustomerSupplierId} = {};
  fiscalDatasById: {[id: string]: FiscalDataId} = {};
  addresssById: {[id: string]: AddressId} = {};

  dateFilter: '15days' | 'always' = '15days';
  get days15FromToday(){
    let date = new Date();
    date.setDate(date.getDate() - 15);
    return Utils.stringDate(date);
  }
  receivedAll: boolean = false;

  unfilteredData: any[];
	data:Array<any>;
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Folio', name: 'name'},
    {title: 'Cliente', name: 'customerName'},
    {title: 'Razón social', name: 'businessName'},
    {title: 'Orden de producción', name: 'odp'},
    {title: 'Clave producto', name: 'odpPrCode'},
    {title: 'Dirección de entrega', name: 'addressName'},
    {title: 'Fecha', name: 'date'},
    {title: 'Cantidad', name: 'quantity'},
    {title: 'Facturas', name: 'bills'},
    { title: 'Acciones', className: 'center minThreeButtons',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
			{ name: 'QC', title: '', styleIcon: 'assignment_turned_in', action: 'onCertificate', styleClass: 'btn-floating btn waves-effect light-blue darken-1' },
			{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit', styleClass: 'btn-floating btn waves-effect light-green darken-1' },
      { name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete', styleClass: 'btn-floating btn waves-effect red darken-2', }  
    ] } }
  ];
  /**
   * assignment_turned_in
   * assistant
   * new_releases
   * star
   */
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
		api: {
      onCertificate: this.onCertificate.bind(this),
			onEdit: this.onEdit.bind(this),
      onDelete: this.onDelete.bind(this)
		}
  };

  remSub: Subscription;
  subs: Subscription[] = [];

  odps: string[] = [];
  odp: string = '';

  bill: '' | 'Con factura' | 'Sin factura' = '';


  constructor(
    private service: RemissionService,
    private customerService: CustomerSupplierService,
    private billService: CustomerBillService,
    private productionOrderService: ProductionOrderService,
    private settings: CatalogsSettingsService,
    private fsService: FirestoreService,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    window['com'] = this;
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = {
          ...this.permissionService.constructPermissionObject(groups, service.collection),
          ...this.permissionService.constructPermissionObject(groups, 'SPECIAL')
        }
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else this.allowed = true;
    });

    let subSet = this.settings.getPayrollSettings('1').subscribe(setting => {
      this.itemsPerPage = setting.tableQuantity;
      subSet.unsubscribe();
    });
    this.subs.push(
      this.customerService.getCustomers().subscribe(customers => {
        this.customers = {};
        this.rowsRead[0] = customers.map(customer => {
          customer.id = customer.id$;
          this.customers[customer.id] = {...customer};
          this.customersById[customer.id] = {...customer} as any;
          return customer;
        })
        if(!this.gotInitialData) this.getInitialData().then(() => {
          this.remSub = this.service.getRemissions({fromDate: this.days15FromToday, fetchRefs: false}).subscribe(this.onSubscribe);
        });
      })
    );
      
      /* this.fsService.colWithIds(Globals.CUSTOMER_BILL_COLLECTION, ref => ref.where('active', '==', true)).then(bills => {
        bills.map(bill => {
          this.billsById[bill.id] = bill as CustomerBillId;
        });
        this.remSub = this.service.getRemissions({fromDate: this.days15FromToday, fetchRefs: false}).subscribe(this.onSubscribe);
      }); */
	}

  ngOnInit() {
  }
  ngOnDestroy() {
    this.remSub.unsubscribe();
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }
  gotInitialData = false;
  async getInitialData(){
    let bills: CustomerBillId[] = await this.fsService.colWithIds<CustomerBillId>(Globals.CUSTOMER_BILL_COLLECTION, ref => ref.where('active', '==', true));
    for(let bill of bills) this.billsById[bill.id] = bill;
    /* let customers: CustomerSupplierId[] = await this.fsService.colWithIds<CustomerSupplierId>(Globals.CUSTOMER_SUPPLIER_COLLECTION, ref => ref.where('active', '==', true));
    for(let customer of customers) this.customersById[customer.id] = customer;
    this.customers = {};
    this.rowsRead[0] = customers.map(customer => {
      this.customers[customer.id] = {...customer};
      return customer;
    }) */
    let fiscalDatas: FiscalDataId[] = await this.fsService.colWithIds<FiscalDataId>(Globals.FISCAL_DATA_COLLECTION, ref => ref.where('active', '==', true));
    for(let fiscalData of fiscalDatas) this.fiscalDatasById[fiscalData.id] = fiscalData;
    let addresss: AddressId[] = await this.fsService.colWithIds<AddressId>(Globals.ADDRESSES_COLLECTION, ref => ref.where('active', '==', true));
    for(let address of addresss) this.addresssById[address.id] = address;
    //console.log(this.billsById);
    //console.log(this.customersById);
    //console.log(this.fiscalDatasById);
    //console.log(this.addresssById);
    this.gotInitialData = true;
  }

  onSubscribe = tempRemissions => {
    this.remissions = {};
    this.unfilteredData = tempRemissions.map((remission) => {
      //console.log(remission);
      //console.log(`Rem ${remission.id}, ${remission.customerRef.id}, ${remission.fiscalDataRef.id}, ${remission.addressRef.id}`);
      const {id, customerObj,fiscalDataObj,addressObj,updatedAt, productionOrder, ...cleanRemission} = remission;
      this.remissions[remission.id] = {...cleanRemission}
      remission.name = remission.folio;
      remission.odp = productionOrder.folio;
      remission.odpPrCode = productionOrder.prClientCode;
      remission.customerName = (this.customersById[remission.customerRef.id] || ({} as any)).name || ''; // remission.customerObj.name;
      remission.businessName = (this.fiscalDatasById[remission.fiscalDataRef.id] || ({} as any)).businessName || ''; // remission.fiscalDataObj.businessName;
      remission.addressName = `${(this.addresssById[remission.addressRef.id] || ({} as any)).street || ''}, #${(this.addresssById[remission.addressRef.id] || ({} as any)).externalNumber || ''}` // `${remission.addressObj.street}, #${remission.addressObj.externalNumber}`;
      remission.bills = 'N.A';
      if(remission.billRefs && remission.billRefs.length){
        remission.bills = '';
        remission.billRefs.map(billId => {
          let bills = remission.bills.split(', ').filter(u => !!u);
          if(bills.includes(billId) || !this.billsById[billId]) return;
          bills.push(this.billsById[billId].folio);
          remission.bills = bills.join(', ');
          /* console.log('getting bill ' + billId);
          if(!window['billsToGet']) window['billsToGet'] = []; window['billsToGet'].push(billId);
          let sub = this.billService.getCustomerBill(billId).subscribe(([bill]) => {
            console.log('got bill ' + billId);
            if(!window['billsGotten']) window['billsGotten'] = []; window['billsGotten'].push(billId);
            sub.unsubscribe();
            let bills = remission.bills.split(', ').filter(u => !!u);
            if(bills.includes(billId)) return;
            bills.push(bill.folio);
            remission.bills = bills.join(', ');
          }) */
        })
        if(!remission.bills) remission.bills = 'Fac. eliminada'
      }
      //remission.billObjs.map(({folio}) => folio).join(', ');
      //remission.billName = remission.status ? remission.billObj.folio : 'N.A.';

      if(!this.odps.includes(remission.odp)) this.odps.push(remission.odp);
      return remission;
    });
    this.filter();
    this.loaded = true;
  }
  onDateFilterChange(){
    console.log(`Changed to ${this.dateFilter}`);
    if(this.dateFilter == 'always' && !this.receivedAll){
      this.receivedAll = true;
      this.loaded = false;
      this.remSub.unsubscribe();
      this.remSub = this.service.getRemissions({fetchRefs: false}).subscribe(this.onSubscribe);
    }else{
      this.filter();
    }
  }
  filter(){
    console.log(`Changed to ${this.dateFilter}`);
    this.data = (this.unfilteredData || []).filter(({odp, bills, date}) => {
      let dateCondition = this.dateFilter == 'always' || date >= this.days15FromToday;
      let odpCondition = !this.odp || odp == this.odp
      let billCondition = !this.bill || this.bill == 'Sin factura' && bills == 'N.A' || this.bill == 'Con factura' && bills != 'N.A';
      //console.log(this.bill, bills, )
      return dateCondition && odpCondition && billCondition;
    });
    this.length = this.data.length;
    console.log(`New Length: ${this.length}`);
    this.onChangeTable(this.config);
  }

  deleteRemission(sid: string) {
    this.service.deleteRemission(sid);
	}

	onCellClick(data: any): any {
		this.service.windowReplace('view', data.row.id);
  }

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.openModalRead(0);
  }

  onCertificate({row: remission}){
    if(!this.permission.qualityCertificate) return toast('Necesita permisos especiales para certificado de calidad.', 2000);
    this.service.windowReplace('certificate', remission.id);
  }

	onEdit(data: any) {
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
    if(data.row.status) return toast('Una remisión convertida no puede ser editada.', 2000);
		this.service.windowReplace('edit', `${data.row.id}/${data.row.customerRef.id}`);
	}

	onDelete(data: any) {
    if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
    if(data.row.status) return toast('Un pedido convertido no puede ser eliminado.', 2000);
    let sub =  this.productionOrderService.getProductionOrder(data.row.productionOrder.id).subscribe(([productionOrder]) => {
      let productionOrderUpdate = {
        remittedQuantity: productionOrder.remittedQuantity - data.row.quantity,
        status: (productionOrder.remittedQuantity - data.row.quantity) < productionOrder.quantity ? productionOrder.lastStatus : productionOrder.status
      };
      sub.unsubscribe();
      this.productionOrderService.putProductionOrder(productionOrderUpdate, data.row.productionOrder.id);
    })
		this.deleteRemission(data.row.id);
  }
  
  onExcel(){
    let columns = this.columns.map(({title}) => title);
    columns.pop();
    let rows: any[] = [
      columns,
      ...this.rows.map(r => [r.name, r.customerName, r.businessName, r.odp, r.addressName, r.date, r.quantity, r.bills])
    ];
    Utils.downloadExcel(rows, `Remisiones_${Utils.today.replace(/-/g, '')}`);
  }
  
	//*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.r_data = this.rowsRead[index];
    
    this.r_config = this.r_configs[index];
  
    this.r_onChangeTable(this.r_config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    this.selectedIds[this.currentReadIndex] = data.row.id;
    this.continue();
  }
  continue(){
    this.closeModalRead();
    this.service.windowReplace('add', this.selectedCustomerId);
  }

  selectedIds: string [] = [];
  customers: any = {};
  get selectedCustomerId(): string { return this.selectedIds[0] }
  get readValid(){ return !!this.selectedCustomerId };
  currentReadIndex: number;
  rowsRead = [[]];
  columnsRead = [
    [//customer
      { title: 'Nombre', name: 'name', sort: 'asc' },
      { title: 'Descripción', name: 'description' },
      { title: 'Correo electrónico', name: 'email' }
    ]
  ]


  r_data:Array<any>;
  r_rows:Array<any> = [];
  r_page:number = 1;
  r_itemsPerPage:number = 5;
  r_maxSize:number = 5;
  r_numPages:number = 1;
  r_length:number = 0;

  
  r_configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));
  r_config = this.r_configs[0];

  /*********** Filter, sort, and pagination */

	r_changePage(page:any, data:Array<any> = this.r_data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  r_changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.r_config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }
    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  r_changeFilter(data:any, config:any):any {
    console.log(this.columnsRead[this.currentReadIndex])
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });
    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.r_config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  r_onChangeTable(config:any, page:any = {page: this.r_page, itemsPerPage: this.r_itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.r_config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.r_config.sorting, config.sorting);
    }

    let filteredData = this.r_changeFilter(this.r_data, this.r_config);
    let sortedData = this.r_changeSort(filteredData, this.r_config);
    this.r_rows = page && config.paging ? this.r_changePage(page, sortedData) : sortedData;
    this.r_length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}